const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case '@meUser/REGISTER':
      return { ...action.meUser };

    case '@meUser/UNREGISTER':
      return {};

    case '@meUser/UPDATE':
      return {
        ...state.meUser,
        ...action.meUser,
      };

    default:
      return state;
  }
};

export default reducer;
